const MuiListItemIcon = {
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.palette.text.secondary,
      minWidth: theme.spacing(5)
    })
  }
};
export {
  MuiListItemIcon
};
//# sourceMappingURL=MuiListItemIcon.js.map
